if (!customElements.get('linked-checkbox')) {
  customElements.define(
    'linked-checkbox',
    class LinkedCheckbox extends HTMLElement {
      constructor() {
        super();

        this._checkboxes = this.querySelectorAll('input');
        for (const checkbox of this._checkboxes) {
          checkbox.addEventListener('change', this._handleChanged.bind(this));
        }
      }

      _handleChanged(event) {
        for (const checkbox of this._checkboxes) {
          checkbox.checked = event.target.checked;
        }

        if (document.querySelector('variant-selects')) {
          document.querySelector('variant-selects').dispatchEvent(new CustomEvent('change'));
        } else {
          document.dispatchEvent(new CustomEvent('related-products:change'));
        }
      }
    }
  );
}